/*
  Gallery counter & overlay controller
  ------------------------------------
  Updates the "3 / 12" counter pill as the gallery scrolls.
  Listens for the theme's existing `carousel:change` events on each
  <media-carousel> inside a <product-gallery>.
*/
(function () {
  'use strict';

  function initGallery(galleryRoot) {
    if (!galleryRoot || galleryRoot.dataset.galleryControlsBound === '1') return;
    galleryRoot.dataset.galleryControlsBound = '1';

    var carousel = galleryRoot.querySelector('media-carousel');
    var current = galleryRoot.querySelector('[data-gallery-counter-current]');
    var total = galleryRoot.querySelector('[data-gallery-counter-total]');
    if (!carousel || !current || !total) return;

    // Update from carousel:change (fired by the theme's media-carousel)
    carousel.addEventListener('carousel:change', function (event) {
      var index = (event.detail && typeof event.detail.index === 'number') ? event.detail.index : 0;
      current.textContent = String(index + 1);
    });

    // Fallback: derive position from active page-dot when available
    var dots = galleryRoot.querySelector('page-dots');
    if (dots) {
      var observer = new MutationObserver(function () {
        var items = Array.from(dots.children);
        var active = items.findIndex(function (el) { return el.getAttribute('aria-current') === 'true'; });
        if (active >= 0) current.textContent = String(active + 1);
      });
      observer.observe(dots, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
    }

    // Hide counter if only 1 visible item
    var visibleCount = carousel.querySelectorAll('.product-gallery__media:not([hidden])').length;
    total.textContent = String(Math.max(visibleCount, 1));
    if (visibleCount <= 1) {
      var overlay = galleryRoot.querySelector('.gallery-overlay');
      if (overlay) overlay.style.display = 'none';
    }

    // Reset thumbnail strip to start on initial load. The theme's
    // <page-dots align-selected> auto-centers the active thumbnail,
    // which pushes earlier thumbnails (including #1) off-screen when
    // a variant's featured media isn't position 1. Reset once at boot
    // so the user always sees the start of the strip; subsequent
    // navigation centers normally.
    var thumbStrip = galleryRoot.querySelector('.product-gallery__thumbnail-list');
    if (thumbStrip) {
      var resetThumbScroll = function () {
        thumbStrip.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      };
      // Run after the page-dots' own scrollTo has fired
      requestAnimationFrame(function () {
        resetThumbScroll();
        // And once more after layout settles (lazy-loaded thumbnail images)
        setTimeout(resetThumbScroll, 120);
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('product-gallery').forEach(initGallery);
  }

  // ── Keyboard nav: ← / → arrows advance the gallery 1:1 (no smooth-scroll throttling) ──
  function bindKeyboardNav() {
    if (window.__sssGalleryKeyboardNav) return;
    window.__sssGalleryKeyboardNav = true;

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.metaKey || event.ctrlKey || event.altKey) return;

      // Don't hijack arrow keys inside form fields, contenteditable, or buttons that handle them
      var t = event.target;
      if (t) {
        var tag = t.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || t.isContentEditable) return;
      }

      // Use first product-gallery on the page (PDP has one)
      var gallery = document.querySelector('product-gallery');
      if (!gallery) return;
      var carousel = gallery.querySelector('media-carousel');
      if (!carousel || typeof carousel.previous !== 'function' || typeof carousel.next !== 'function') return;

      // Skip if gallery is hidden (offsetParent === null)
      if (!carousel.offsetParent) return;

      event.preventDefault();
      // animate=false → instant scroll, so rapid keypresses each register
      if (event.key === 'ArrowLeft') {
        carousel.previous(false);
      } else {
        carousel.next(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); bindKeyboardNav(); });
  } else {
    initAll();
    bindKeyboardNav();
  }

  // Re-init on Shopify section reload (theme editor) and AJAX swaps.
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:reorder', function (event) { initAll(event.target); });
})();
